"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixDataQueryReferencedResult = (function () {
  function WixDataQueryReferencedResult(provider, collectionName, referenceAttribute, holdingItemId, result) {
    var options = arguments.length <= 5 || arguments[5] === undefined ? {} : arguments[5];

    _classCallCheck(this, WixDataQueryReferencedResult);

    this.provider = provider;
    this.collectionName = collectionName;
    this.referenceAttribute = referenceAttribute;
    this.holdingItemId = holdingItemId;
    this.result = result;
    this.options = options;

    var _options$skip = options.skip;
    var skip = _options$skip === undefined ? 0 : _options$skip;
    var _options$limit = options.limit;
    var limit = _options$limit === undefined ? 50 : _options$limit;

    this.skip = skip;
    this.limit = limit;
  }

  _createClass(WixDataQueryReferencedResult, [{
    key: "hasNext",
    value: function hasNext() {
      return this.skip + this.limit < this.result.totalCount;
    }
  }, {
    key: "hasPrev",
    value: function hasPrev() {
      return this.skip > 0;
    }
  }, {
    key: "next",
    value: function next() {
      return _queryForPage.call(this, this.skip + this.limit);
    }
  }, {
    key: "prev",
    value: function prev() {
      return _queryForPage.call(this, this.skip - this.limit);
    }
  }, {
    key: "items",
    get: function get() {
      return this.result.items;
    }
  }, {
    key: "totalCount",
    get: function get() {
      return this.result.totalCount;
    }
  }]);

  return WixDataQueryReferencedResult;
})();

exports.WixDataQueryReferencedResult = WixDataQueryReferencedResult;

function _queryForPage(skip) {
  var _this = this;

  var actualSkip = skip >= 0 ? skip : 0;
  var optionsToPass = Object.assign({}, this.options, { skip: actualSkip, limit: this.limit });

  return this.provider.queryReferenced(this.collectionName, this.holdingItemId, this.referenceAttribute, optionsToPass).then(function (result) {
    return new WixDataQueryReferencedResult(_this.provider, _this.collectionName, _this.referenceAttribute, _this.holdingItemId, result, optionsToPass);
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/multiref.js
// module id = 129
// module chunks = 0